import { Box, useMediaQuery } from '@material-ui/core'
import React from 'react'
import Thumbnail from './Thumbnail'
import { tabletBreakpoint } from '../../lib/helper/viewportHelper'
import theme from '../../theme'

function Thumbnails(props) {
    const length = props.length ?? 3
    const thumbnails = props.data ?? [...Array(length)]
    const isSmall = useMediaQuery(theme.breakpoints.down(tabletBreakpoint))

    return (
        <Box
            style={
                (props.style)
                    ? props.style
                    : {
                        display: "flex",
                        justifyContent: isSmall ? "center" : "space-between",
                        rowGap: 45,
                        columnGap: isSmall ? "1rem": "0",
                        margin: 45,
                        flexWrap: "wrap",
                    }
            }

        >
            {
                thumbnails.map((thumbnailProps, i) => {
                    const sizes = props.thumbnailSizes
                    const clampedSizeIndex = Math.min(i, sizes.length - 1)
                    const currentSize = sizes[clampedSizeIndex]

                    return (
                        <Thumbnail
                            key={i}
                            {...thumbnailProps}
                            loading={props.isFetching || (thumbnailProps === undefined)}
                            width={currentSize.percent}
                            style={{ minHeight: isSmall? "auto" : 145 }}
                            srcWidth={currentSize.srcWidth}
                        />
                    )
                })
            }
        </Box>
    )
}

export default Thumbnails
